import { useFieldContext } from '../FieldContext';
import { formatDateTime } from '../format';
import { EmptyValue } from './EmptyValue';

export function DateTimeDisplay() {
  const { value } = useFieldContext();
  if (typeof value !== 'string' || value.length === 0) {
    return <EmptyValue />;
  }
  return (
    <time dateTime={value} className="block whitespace-nowrap tabular-nums">
      {formatDateTime(value)}
    </time>
  );
}
